import styled, { css } from 'styled-components';
import { tagStyles } from '../Typography/styles';

export const arrowTick = isDownArrow => css`
  &::after {
    content: ' ';
    display: inline-block;
    vertical-align: middle;
    border-right: 2px solid ${({ theme }) => theme.colors.text.secondary};
    border-bottom: 2px solid ${({ theme }) => theme.colors.text.secondary};
    width: 10px;
    height: 10px;
    margin: 0 13px 0 28px;
    transform: rotate(${isDownArrow ? '45deg' : '-45deg'});
  }
`;

export const StyledContainer = styled.div`
  height: 55px;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  ${({ isDownArrow, withArrow }) => withArrow && arrowTick(isDownArrow)}
`;

export const StyledTitle = styled.div`
  ${tagStyles.body_1}
  margin-bottom: 2px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const StyledValue = styled.div`
  ${tagStyles.body_1}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

export const ContainerPadding = styled.div`
  padding: 10px 0;
  width: ${({ safeSpace }) => `calc(100% - ${safeSpace}px)`};
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  width: 35px;
  right: 0;
  top: 0;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: 0 10px 0 10px;
  margin-left: 25px;
`;

export const StyledIcon = styled.div`
  width: 30px;
  height: 30px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
